import React, { memo } from "react";
import { FaUser, FaChild } from "react-icons/fa";
import { formatMoney, toNumberOrNull } from "../general/helper";

const ActivityPricesCard = memo(function ActivityPricesCard({
  general,
  activity,
  title = "Prices",
  labels = { adult: "Adult", child: "Child" },
  className = "",
}) {
  const adultPrice = toNumberOrNull(activity?.defaultPriceAdult);
  const childPrice = toNumberOrNull(activity?.defaultPriceChildren);

  if (adultPrice === null && childPrice === null) return null;

  return (
    <div className={`mx-2 mt-3 ${className}`}>
      <div className="">
        {/* Header */}
        {/* <div className="flex items-center gap-2 px-4 pt-3">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-100">
            <FaEuroSign className="text-gray-700" />
          </span>
          <span className="text-sm font-semibold text-gray-900">{title}</span>
        </div> */}

        {/* Body */}
        <div className="px-4 pb-3 pt-2">
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            {adultPrice !== null && (
              <div className="flex items-center justify-between rounded-lg bg-gray-50 px-3 py-2 border border-gray-100">
                <div className="flex items-center gap-2">
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-white border border-gray-200">
                    <FaUser className="text-gray-700" />
                  </span>
                  <div className="leading-tight">
                    <div className="text-xs text-gray-500">{labels.adult}</div>
                    <div className="text-sm font-semibold text-gray-900">
                      {formatMoney(adultPrice, general)}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {childPrice !== null && (
              <div className="flex items-center justify-between rounded-lg bg-gray-50 px-3 py-2 border border-gray-100">
                <div className="flex items-center gap-2">
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-white border border-gray-200">
                    <FaChild className="text-gray-700" />
                  </span>
                  <div className="leading-tight">
                    <div className="text-xs text-gray-500">{labels.child}</div>
                    <div className="text-sm font-semibold text-gray-900">
                      {formatMoney(childPrice, general)}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Optional: tiny footer hint (remove if you don’t want it) */}
          {/* <div className="mt-2 text-[11px] text-gray-400">Taxes included</div> */}
        </div>
      </div>
    </div>
  );
});

export default ActivityPricesCard;
